import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";

export const useLoyaltySettingsByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["loyalty-setting-by-admin"],
    queryFn: () =>
      fetcher<{
        currencyPerPoint: number;
        pointsPerCurrency: number;
        pointsPerInviteAcceptance: number;
      }>(`loyalty-setting`, token),
  });
};
